import React from "react";
import { ConfidencePill } from "./Pills";

/** A KPI card with main value, unit, optional sub label and confidence badge. */
export default function KpiCard({
  label,
  value,
  unit,
  Icon,
  accent = "default",  // default|amber|green|red|cyan|blue|purple
  sub,
  confidence,           // measured|estimated|simulated|manual|unknown
  testid,
}) {
  const accentColor = {
    default: "text-foreground",
    amber: "text-[#F59E0B]",
    green: "text-[#10B981]",
    red: "text-[#E11D48]",
    cyan: "text-[#3B82F6]",
    blue: "text-[#60A5FA]",
    purple: "text-[#FAFAFA]",
  }[accent] || "text-foreground";

  return (
    <div
      className="card-base p-5 flex flex-col justify-between min-h-[8.5rem]"
      data-testid={testid || `kpi-card-${(label || "").toLowerCase().replace(/\s+/g, "-")}`}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="flex items-center gap-2 text-muted-foreground">
          {Icon ? <Icon className={`w-3.5 h-3.5 ${accentColor}`} strokeWidth={2} /> : null}
          <span className="label-tiny">{label}</span>
        </div>
        {confidence ? <ConfidencePill level={confidence} /> : null}
      </div>
      <div className="flex items-baseline gap-1.5 mt-3">
        <span className={`font-heading text-3xl font-semibold tracking-tight ${accentColor}`}>
          {value}
        </span>
        {unit ? <span className="text-xs text-muted-foreground font-medium">{unit}</span> : null}
      </div>
      {sub ? <div className="text-xs text-muted-foreground mt-1.5">{sub}</div> : null}
    </div>
  );
}
